import { fetchApi } from "../components/FetchApi";
import { wrapServiceCall } from "./ServiceUtils";

export const getCategoryAttributes = (categoryId) =>
  wrapServiceCall(() =>
    fetchApi(`/categories/attributes?category=${categoryId}`, { method: "GET" })
  );
